// Customizable Area Start
import React, { Component } from "react";
import { styled } from "@material-ui/core/styles";
import ImageViewer from "react-simple-image-viewer";
import { IconButton } from "@material-ui/core";
import { CloseRounded } from "@material-ui/icons";

const Image = styled("img")({
  height: "60px",
  width: "60px",
  borderRadius: "8px",
});

const Video = styled("video")({
  width: "150px",
  height: "200px",
  // borderRadius: "8px",
  objectFit: "cover",
  cursor: "pointer",
  display: "block",
  "@media (max-width: 768px)": {
    width: "100% !important",
    maxWidth: "140px !important",
    height: "200px !important",
    minHeight: "200px",
    maxHeight: "300px",
    objectFit: "contain",
  },
});

const CloseButton = styled(IconButton)({
  backgroundColor: "#000",
  zIndex: 1501,
  "&:hover": {
    backgroundColor: "#000",
  },
  "& svg": {
    color: "#fff",
  },
});

interface ICommentImageProps {
  files:
    | {
        url?: string;
        link?: string;
        link_content_type?: string;
      }[]
    | null;
}

interface State {
  isImageOpen: boolean;
}

export class CommentImage extends Component<ICommentImageProps, State> {
  constructor(props: ICommentImageProps) {
    super(props);

    this.state = {
      isImageOpen: false,
    };
  }

  openImageFull = () => {
    this.setState({ isImageOpen: true });
  };

  closeImageFull = () => {
    this.setState({ isImageOpen: false });
  };

  isVideo = (file: any) => {
    if (!file) return false;
    const url = file.url || file.link || "";
    const contentType = file.link_content_type || "";
    return (
      contentType.includes("video") ||
      url.includes(".mp4") ||
      url.includes(".mov") ||
      url.includes(".avi") ||
      url.includes(".webm") ||
      url.includes(".mpeg")
    );
  };

  render() {
    const { files } = this.props;
    const { isImageOpen } = this.state;

    if (!files) {
      return null;
    }

    // Handle both array and object formats
    let filesArray: any[] = [];
    if (Array.isArray(files)) {
      filesArray = files.filter(f => f != null);
    } else if (files && typeof files === 'object' && !Array.isArray(files)) {
      const filesObj = files as any;
      
      if (Array.isArray(filesObj.data)) {
        filesArray = filesObj.data.filter((f: any) => f != null);
      } else if (filesObj.link || filesObj.url) {
        filesArray = [filesObj];
      } else {
        const possiblePaths = [
          filesObj.attributes?.files,
          filesObj.files,
          filesObj.data?.files
        ];
        
        for (const path of possiblePaths) {
          if (Array.isArray(path) && path.length > 0) {
            filesArray = path.filter((f: any) => f != null);
            break;
          } else if (path && (path.link || path.url)) {
            filesArray = [path];
            break;
          }
        }
      }
    }
    
    if (filesArray.length === 0) {
      return null;
    }

    const firstFile = filesArray[0];
    const fileUrl = firstFile.url || firstFile.link || "";
    
    if (!fileUrl || fileUrl.trim() === "") {
      return null;
    }
    
    const isVideoFile = this.isVideo(firstFile);

    // Check if mobile
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    
    return (
      <>
        {isVideoFile ? (
          <Video
            src={fileUrl}
            controls
            playsInline
            preload="metadata"
            style={{
              width: isMobile ? "100%" : "150px",
              maxWidth: isMobile ? "150px" : "150px",
              height: isMobile ? "200px" : "200px",
              minHeight: isMobile ? "200px" : "200px",
              maxHeight: isMobile ? "300px" : "200px",
              borderRadius: "8px",
              objectFit: isMobile ? "contain" : "cover",
              marginTop: "8px",
              marginLeft: "10px",
              display: "block",
              backgroundColor: "#000",
            }}
          />
        ) : (
          <>
            <Image
              src={fileUrl}
              alt="Image"
              onClick={this.openImageFull}
            />
            {isImageOpen && (
              <ImageViewer
                src={[fileUrl]}
                currentIndex={0}
                closeComponent={
                  <CloseButton size="small" onClick={this.closeImageFull}>
                    <CloseRounded />
                  </CloseButton>
                }
                backgroundStyle={{
                  zIndex: 1500,
                  backgroundColor: "rgba(0,0,0,0.45)",
                  borderRadius: 8
                }}
                disableScroll={true}
                closeOnClickOutside={true}
                onClose={this.closeImageFull}
              />
            )}
          </>
        )}
      </>
    );
  }
}

export default CommentImage;
// Customizable Area End
